import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { useWebDrawer } from '@components/Web/Drawer/WebDrawerContext';
import { PopupIcon } from '@components/Web/PopupIcon';

type Props = Pick<ComponentProps<typeof PopupIcon>, 'backgroundColor'> & {
  popSize?: 'big' | 'small';
};

export const ProfileEditModal = ({ popSize, ...rest }: Props) => {
  const { setIsEditProfileOpen } = useWebDrawer();
  const { t } = useTranslation('shared');

  const menuList: ComponentProps<typeof PopupIcon>['popupProps']['menuList'] = [
    {
      iconName: 'Edit3',
      name: t('shared:editProfile'),
      onSelect: () => {
        setIsEditProfileOpen(true);
      },
    },
  ];

  return (
    <>
      <PopupIcon
        enableHoverEffect={true}
        {...rest}
        name='MoreVertical'
        variant={popSize === 'big' ? 'l' : 's'}
        paddingHorizontal='xs'
        paddingVertical='xxxs'
        color='textPrimary'
        popupProps={{
          menuList,
          position: ['right', 'top'],
          offset: [0, 0],
        }}
      />
    </>
  );
};
